import { ACCENT, ACCENT_DARK, TEAL, BG_WARM } from '../utils/theme';

const HERO_IMAGE = 'https://storage.readdy-site.link/project_files/a66d5797-4a06-45fc-81bf-d0a4597c8085/cad05462-fe9f-41bc-9ecb-19336b5868be_34027320_m.jpg?v=8c56c403d040028059aa724f3e081483';

interface HeroSectionProps {
  onOpenModal: () => void;
  onScrollToJobs: () => void;
}

export default function HeroSection({ onOpenModal, onScrollToJobs }: HeroSectionProps) {
  return (
    <section
      data-track-view="true"
      data-element-id="hero_section"
      data-element-type="section"
      data-element-name="ファーストビュー"
      data-element-index="0"
      style={{
        position: 'relative',
        maxWidth: 430,
        margin: '0 auto',
        overflow: 'hidden',
        minHeight: 520,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
      }}
    >
      <div
        style={{
          position: 'absolute',
          inset: 0,
          backgroundImage: `url(${HERO_IMAGE})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center top',
          zIndex: 0,
        }}
      />
      <div
        style={{
          position: 'absolute',
          inset: 0,
          background: `linear-gradient(to bottom, rgba(255,240,245,0.30) 0%, rgba(255,240,245,0.65) 38%, rgba(255,240,245,0.93) 72%, ${BG_WARM} 100%)`,
          zIndex: 1,
        }}
      />
      <div style={{ position: 'relative', zIndex: 2, padding: '0 20px 28px' }}>
        <h1
          style={{
            fontSize: 22,
            fontWeight: 900,
            color: '#2a2a2a',
            lineHeight: 1.55,
            letterSpacing: '-0.02em',
            marginBottom: 12,
          }}
        >
          いまの仕事は好き。<br />
          条件だけ、もう少し良くしたい。
        </h1>
        <p style={{ fontSize: 13, color: '#555', lineHeight: 1.7, marginBottom: 22 }}>
          <span
            style={{
              display: 'inline-block',
              background: `${TEAL}18`,
              color: TEAL,
              borderRadius: 6,
              padding: '2px 8px',
              fontSize: 12,
              fontWeight: 700,
              marginBottom: 6,
            }}
          >
            元看護師のコンサルタントが対応
          </span>
          <br />
          非公開求人{' '}
          <strong style={{ fontSize: 18, fontWeight: 900, color: ACCENT }}>
            3,000件以上
          </strong>
          の中から、<br />
          あなたの希望にぴったりの職場を探します。
        </p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <button
            onClick={onOpenModal}
            data-track-tap="true"
            data-element-id="cta_primary"
            data-element-type="button"
            data-element-name="近いうちに条件を良くしたい"
            data-element-index="0"
            data-track-view="true"
            style={{
              background: `linear-gradient(135deg, ${ACCENT} 0%, ${ACCENT_DARK} 100%)`,
              color: '#fff',
              border: 'none',
              borderRadius: 12,
              padding: '16px 24px',
              fontSize: 15,
              fontWeight: 700,
              cursor: 'pointer',
              letterSpacing: '0.01em',
              boxShadow: `0 4px 16px ${ACCENT}55`,
              whiteSpace: 'nowrap',
            }}
          >
            近いうちに条件を良くしたい
          </button>
          <button
            onClick={onScrollToJobs}
            data-track-tap="true"
            data-element-id="cta_secondary"
            data-element-type="button"
            data-element-name="まずは求人を見てみたい"
            data-element-index="1"
            data-track-view="true"
            style={{
              background: 'rgba(255,255,255,0.85)',
              color: '#555',
              border: '1.5px solid rgba(0,0,0,0.12)',
              borderRadius: 12,
              padding: '13px 24px',
              fontSize: 14,
              fontWeight: 500,
              cursor: 'pointer',
              backdropFilter: 'blur(4px)',
              whiteSpace: 'nowrap',
            }}
          >
            まずは求人を見てみたい
          </button>
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', gap: 16, marginTop: 18 }}>
          {[
            { icon: 'ri-gift-line',         text: '完全無料' },
            { icon: 'ri-timer-line',         text: '1〜2分で完了' },
            { icon: 'ri-shield-check-line', text: 'しつこい連絡なし' },
          ].map((badge) => (
            <div key={badge.text} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3 }}>
              <div
                style={{
                  width: 32,
                  height: 32,
                  borderRadius: '50%',
                  background: `rgba(92,191,176,0.15)`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <i className={badge.icon} style={{ fontSize: 15, color: TEAL }} />
              </div>
              <span style={{ fontSize: 10, color: '#666', fontWeight: 500, whiteSpace: 'nowrap' }}>
                {badge.text}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
